import taskInstanceListItemOptionsUrl from './taskInstanceListItemOptions.html';

class TaskInstanceListItemOptionsCtrl {
  canEdit = false;

  constructor(
    Authentication,
    AlertService,
    ConfirmService,
    ShiftTasksService,
    ShiftTasksActionsService,
    sdk
  ) {
    'ngInject';

    Object.assign(this, {
      Authentication,
      AlertService,
      ConfirmService,
      ShiftTasksService,
      ShiftTasksActionsService,
      sdk,
    });

    this.canInteractWithTaskInstance = sdk('helpers/shiftTasks/canInteractWithTaskInstance');
  }

  $onInit() {
    this.setCanEditFlag();
  }

  get canInteractWithTask() {
    return this.canInteractWithTaskInstance(this.instance, this.Authentication.user);
  }

  setCanEditFlag() {
    if (!this.instance) {
      this.canEdit = false;
    } else {
      const { isManager, canActOnLocation } = this.Authentication.user;
      this.canEdit = isManager && canActOnLocation({ id: this.instance.locationId });
    }
  }

  async deleteTask() {
    this.ConfirmService.ask(
      {
        question: `Are you sure you want to delete task: ${this.instance.title}?`,
        title: 'Please confirm',
        confirm: 'Delete',
      },
      () => {
        this.ShiftTasksService.remove(this.instance);
      }
    ).ignoreCancel();
  }

  async completeTask() {
    try {
      this.instance = await this.ShiftTasksActionsService.completeTask(this.instance);
    } catch {
      // action cancelled
    }
  }

  async reopenTask() {
    try {
      await this.ShiftTasksActionsService.reopenTask(this.instance);
    } catch {
      // action cancelled
    }
  }
}

export default {
  templateUrl: taskInstanceListItemOptionsUrl,
  controller: TaskInstanceListItemOptionsCtrl,
  controllerAs: 'ctrl',
  bindings: {
    instance: '<',
  },
};
